import type { ReactNode } from 'react';

import { cn } from '~/utils/cn';

interface Props {
  /** A small lucide icon, or a connector logo — omitted for a chip whose content is self-evident
   *  (e.g. the person chip, which already carries its own avatar). */
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

/**
 * One soft, bordered pill for a header meta fact (design round 2 §M-A): an optional icon then
 * text. The run and experiment headers render every meta-line fact this way instead of the
 * generic "·"-joined sentence, so destination, volume, timing and who-ran-it each read as their
 * own small fact instead of running together.
 */
export function HeaderMetaChip({ icon, children, className }: Props) {
  return (
    <span
      className={cn(
        'bg-muted/40 text-muted-foreground inline-flex min-w-0 items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs whitespace-nowrap',
        className,
      )}
    >
      {icon}
      {children}
    </span>
  );
}
